export default "#### Have your licence handy\n\nSpeed up the paperwork by having your licence ready, and making sure the details you give us match.\n";